import { useJbpSettings } from 'legacy/lut/features/partner360/jbpSettings'

export const useCockpitEltCreationPeriod = () => {
  const { jbpSettings } = useJbpSettings()

  return {
    fYear: jbpSettings.fYearELT,
    fQuarter: jbpSettings.fQuarterELT,
  }
}
